import React from "react"
import "./RaffleParticipating.scss"
import RaffleHolder from "./RaffleHolder"
import { useRaffle } from "../RaffleContext"
import I18n from "@helper/i18nInstance"

const RaffleParticipating: React.FC = () => {
  const {
    raffle,
    wasAlreadyParticipatingOnFirstLoad,
  } = useRaffle()
  const email = raffle?.participation?.type === "participating" ? raffle.participation.email : ""

  return <RaffleHolder testId="raffle-participating">
    <div className="neo__raffleParticip">
      <h3>{wasAlreadyParticipatingOnFirstLoad ? I18n.t("raffle.already_participating_title") : I18n.t("raffle.participation_successful_title")}</h3>
      <div dangerouslySetInnerHTML={{__html: I18n.t("raffle.participation_successful_info", {username: `<strong>${email}</strong>`})}} />
    </div>
  </RaffleHolder>
}

export default RaffleParticipating
